module.exports = __webpack_public_path__ + "img/female-teenager-head.c12d5f0e.svg";